export const REGISTER_BEGAN = 'auth/REGISTER_BEGAN'
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS'
export const REGISTER_REJECTED = 'auth/REGISTER_REJECTED'
export const REGISTER_FAILED = 'auth/REGISTER_FAILED'

export const CHANGE_PASSWORD_BEGAN = "auth/CHANGE_PASSWORD_BEGAN"
export const CHANGE_PASSWORD_SUCCESS = "auth/CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAILED = "auth/CHANGE_PASSWORD_FAILED"

export const SEND_NEW_PASSWORD_BEGAN = "auth/SEND_NEW_PASSWORD_BEGAN"
export const SEND_NEW_PASSWORD_SUCCESS = "auth/SEND_NEW_PASSWORD_SUCCESS"
export const SEND_NEW_PASSWORD_FAILED = "auth/SEND_NEW_PASSWORD_FAILED"

export const LOGIN_BEGAN = 'auth/LOGIN_BEGAN'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const LOGIN_REJECTED = 'auth/LOGIN_REJECTED'
export const LOGIN_FAILED = 'auth/LOGIN_FAILED'

export const CHECK_TOKEN_BEGAN = 'auth/CHECK_TOKEN_BEGAN'
export const CHECK_TOKEN_SUCCESS = 'auth/CHECK_TOKEN_SUCCESS'
export const CHECK_TOKEN_REJECTED = 'auth/CHECK_TOKEN_REJECTED'
export const CHECK_TOKEN_FAILED = 'auth/CHECK_TOKEN_FAILED'

export const DISCONNECT = 'auth/DISCONNECT'

export const SAVE_FIREBASE_TOKEN = 'auth/SAVE_FIREBASE_TOKEN'